import { useSearchParams } from 'react-router-dom';
import { configService } from '../services';
import { apiService } from '../services';

export const useToken = () => {
  const [searchParams] = useSearchParams();

  const getToken = async () => {

    let code = "";

    if (searchParams.get("code") !== null && searchParams.get("code") !== "") {
      code = searchParams.get("code") as string;
    }

    if (code !== "") {
      await apiService.instance.checkToken(code);

      //get local storage value for return_url
      const returnUrl = localStorage.getItem("return_url");
      if (returnUrl) {
        localStorage.removeItem("return_url");
        window.location.href = returnUrl;
      }
      else {
        window.location.href = '/';
      }
    }
  };

  return {
    getToken
  }
}

export const doLogin = (returnUrl = '/connect/authorize') => {


  //Get referrer code from local storage
  let referrerCode = localStorage.getItem("referrerCode");


  //Set return url in local storage so we can redirect back to the page after login
  localStorage.setItem("return_url", window.location.href);


  //Check if the app is zebratechnologies and redirect to Azure (SAML2) login
  const appId = process.env.REACT_APP_CLIENTID;
  if (appId === "acmetechpep") {
    var newUrl = `${configService.current().apiUri}/account/LoginWithAzure/?returnurl=%2Fconnect%2Fauthorize%3Fclient_id%3D${configService.current().clientId}%26redirect_uri%3D${configService.current().appUri}%2F%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520offline_access%2520roles%2520email%26referrerCode=${referrerCode}`;
    window.location.href = newUrl;
    return;
  }


  //Default login flow
  if (referrerCode) {
    window.location.href = `${configService.current().apiUri}/account/login/?returnurl=%2Fconnect%2Fauthorize%3Fclient_id%3D${configService.current().clientId}%26redirect_uri%3D${configService.current().appUri}%2F%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520offline_access%2520roles%2520email%26referrerCode=${referrerCode}`;
  }
  else {
    window.location.href = `${configService.current().apiUri}/account/login/?returnurl=%2Fconnect%2Fauthorize%3Fclient_id%3D${configService.current().clientId}%26redirect_uri%3D${configService.current().appUri}%2F%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520offline_access%2520roles%2520email`;
  }


}

export const doLogout = () => {
  window.localStorage.clear();
  window.location.href = '/';
}